/* Text extraction + language/voice helpers for the Listen (TTS) feature. */

export const LANG_NAMES = { ml: "Malayalam", hi: "Hindi", es: "Spanish", fr: "French", de: "German", ta: "Tamil",
  ar: "Arabic", pt: "Portuguese", it: "Italian", ja: "Japanese", zh: "Chinese", "zh-CN": "Chinese",
  nl: "Dutch", ru: "Russian", bn: "Bengali", te: "Telugu", kn: "Kannada", pa: "Punjabi", ur: "Urdu" };

/* Page language — Google Translate sets <html lang="ml"> when the page is translated. */
export const pageLang = () => (document.documentElement.lang || "en").split("-")[0].toLowerCase() || "en";

export const voiceFor = (lang) => {
  const voices = window.speechSynthesis.getVoices() || [];
  if (!voices.length) return "unknown"; // voices not loaded yet — let the browser resolve at speak time
  return voices.find((v) => v.lang && v.lang.toLowerCase().startsWith(lang)) || null;
};

/* Leaf text blocks: elements with visible text that contain no nested block elements. */
export const collectBlocks = (root) => {
  const out = [];
  const walk = (node) => {
    for (const child of node.children) {
      const hasNestedBlocks = child.querySelector("p, div, li, h1, h2, h3, h4, h5, blockquote, figcaption, section");
      const text = (child.innerText || "").trim();
      if (!text || /^(script|style|iframe|img|svg|button|input|select)$/i.test(child.tagName)) continue;
      if (hasNestedBlocks) walk(child);
      else out.push(child);
    }
  };
  walk(root);
  return out;
};

/* Sentence-sized chunks for the device Web Speech engine. */
export const buildChunks = (blocks) => {
  const chunks = [];
  for (const block of blocks) {
    const text = (block.innerText || "").replace(/\s+/g, " ").trim();
    const sentences = text.match(/[^.!?]+[.!?]+|\S[^.!?]*$/g) || [text];
    let cur = "";
    for (const s of sentences) {
      if ((cur + s).length > 220 && cur) { chunks.push({ text: cur, block }); cur = s; } else cur += s;
    }
    if (cur.trim()) chunks.push({ text: cur, block });
  }
  return chunks.slice(0, 600);
};

/* Larger chunks for Cloud Voices (server TTS, one request per paragraph). */
export const cloudChunks = (blocks) => {
  const out = [];
  for (const block of blocks) {
    const text = (block.innerText || "").replace(/\s+/g, " ").trim();
    if (!text) continue;
    for (let i = 0; i < text.length; i += 3800) out.push({ text: text.slice(i, i + 3800), block });
  }
  return out.slice(0, 80);
};
